import classNames from 'classnames';
import Resources from 'components/MapPage/CorporateViewTabs/Resources';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';
import { UscgMapLayout } from 'components/MapPage/UscgMapLayout';

/**
 * Assets as a full page in the incident workspace.
 *
 * The hub renders the same `Resources` on shadcn primitives and gets its dark
 * palette from the `dark` class `MapSidebarContainer` puts above it. Tailwind's
 * dark variant is scoped to a `.dark` ancestor, so without one here the shared
 * table and list would resolve the light tokens and this page alone would come
 * out white.
 */
export const ResourcesFullPage = () => {
  const { isMapVisible } = useUscgMapContext();
  return (
    <div
      className={classNames('d-flex flex-column h-100 w-100', {
        'iap-response__main': isMapVisible,
      })}
      style={{ minHeight: 0, overflow: isMapVisible ? 'hidden' : undefined }}
    >
      <UscgMapLayout>
        <div className="maincontent dark tw:min-h-0 tw:flex-1 tw:overflow-y-auto tw:text-foreground ps-2 pe-2">
          <Resources />
        </div>
      </UscgMapLayout>
    </div>
  );
};
